module.exports = __webpack_public_path__ + "static/img/Tyrone-Munro.7fa20d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyrone-Munro.jpg
// module id = 69SL
// module chunks = 0